import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'currency-leu', 'IconCurrencyLeu', [["path",{"d":"M17 18h-7a3 3 0 0 1 -3 -3v-10","key":"svg-0"}]]);